//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vueFilter from "@/common/filter/vuefilter.js";

export default {
  name: "index",
  data() {
    return {
      proposalId: "",
      initData: [],
      isLoading: false,
      btnSrcList: {
        lilly: require("../assets/images/addBtn2.png"),
        roche: require("../assets/images/addBtn.png")
      },
      btnSrc: "",
      isShowEditBtn: false,
    };
  },
  components: {},
  created() {
    if (this.$route.query.status != null && this.$route.query.status >= 50) {
      this.$router.push({
        path: "/confirmSettlement",
        query: {
          proposalId: this.iStorage.get('eventData').proposalId
        }
      });
    }
    //监听安卓返回键
    this.setRouteListeners("indexGoBack");
    this.$root.$eventHub.$on("indexGoBack", data => {
      this.indexGoBack();
      this.$root.$eventHub.$off("indexGoBack"); //解绑当前监听，否则下轮监听还会持续叠加
    });
  },
  mounted() {
    this.btnSrc = this.btnSrcList.roche;
    let eventData = this.iStorage.get('eventData') || {};
    if (eventData.isShowEditBtn || eventData.tenant_code == 'lilly') {
      this.isShowEditBtn = true;
    } else {
      this.isShowEditBtn = false;
    }
    this.proposalId = eventData.proposalId;
    // this.proposalId = "8c4860a1-af6a-464d-b3a6-800616105e81"; //模拟数据，提交请注释
    this.getInitData();
    if (eventData != null && eventData) {
      switch (eventData.tenant_code) {
        case "lilly":
          this.btnSrc = this.btnSrcList.lilly;
          break;
        case "roche":
          this.btnSrc = this.btnSrcList.roche;
          break;
        case "novartis-master":
          this.btnSrc = '';
          break;
        default:
          this.btnSrc = this.btnSrcList.roche;
          break;
      }
    }
  },
  methods: {
    indexGoBack() {
      this.removeRouteListeners("indexGoBack");
      //刷新页面
      var sendData = JSON.stringify({handle: "reload_event_detail"});
      this.iJsBridge.call({
        method: "SMGeneral.setResultToNative",
        postData: sendData
      });
      this.iJsBridge.close();
    },
    //获取初始化数据
    async getInitData() {
      let params = {
        Filters: {
          ProposalId: this.proposalId
        }
      };
      const res = await this.axios.post(this.api.QueryItems, params);
      if (res && res.success) {
        this.isLoading = false;
        this.initData = res.content;
        this.initData.items.forEach((item, index) => {
          item.dtStart = vueFilter.formatDate(item.dtStart, "yyyy/MM/dd");
          item.dtEnd = vueFilter.formatDate(item.dtEnd, "yyyy/MM/dd");
        });
      }
    },
    onClickLeft() {
      // console.log(this.iJsBridge);
      //刷新页面
      var sendData = JSON.stringify({handle: "reload_event_detail"});
      this.iJsBridge.call({
        method: "SMGeneral.setResultToNative",
        postData: sendData
      });
      //关闭站点
      this.iJsBridge.close();
    },
    onClickRight() {
      this.$dialog
        .confirm({
          title: "再次确认",
          message: "您是否确认提交?"
        })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    },
    toEditDemand(SaveMode, itemId) {
      this.$router.push({
        path: "/editDemand",
        query: {
          SaveMode: SaveMode,
          ItemId: itemId,
          ProposalId: this.proposalId
        }
      });
    },
    CancelMethod(ItemId, index) {
      this.$dialog
        .confirm({
          title: "再次确认",
          message: "您是否确认取消该项?"
        })
        .then(async () => {
          let params = {
            ItemId: ItemId,
            ProposalId: this.proposalId
          };
          let res = await this.axios.post(this.api.Cancel, params);
          if (res && res.success) {
            this.initData.items[index].status = -1;
            this.getInitData();
            this.$toast("取消成功");
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    //下拉刷新
    async onRefresh() {
      this.getInitData();
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/index.vue